import { z } from 'zod';
import { Api, ApiFilterBuilder } from '@automapa/svelte-automapa-template';
import { SettingsApi } from '../../components/Settings/SettingsApi';
import { get } from 'svelte/store';
import { api } from '../../../stores/api';
import { StatusApiDataRequestSchema } from './WidgetOneApi';

export const WidgetItemSchema = z.object({
    id: z.string().describe('Unique id in all widgets in application scope (this user)'),
    order: z.number(),
    componentId: z.number(),
    settings: StatusApiDataRequestSchema,
});
export type WidgetItemType = z.infer<typeof WidgetItemSchema>;

export const WidgetApiDataSchema = z
    .object({
        mainQuery: z.any().catch({}),
        components: z.array(WidgetItemSchema).catch([]),
    })
    .catch({ components: [] });
export type WidgetApiDataType = z.infer<typeof WidgetApiDataSchema>;

export class WidgetApi {
    private dashboardKey: number;
    private api: Api;

    constructor(dashboardKey: number, api: Api) {
        this.dashboardKey = dashboardKey;
        this.api = api;
    }

    getDashboardKey(): number {
        return this.dashboardKey;
    }

    async save(data: WidgetApiDataType): Promise<any> {
        return this.api.patch(
            `/dashboard_template/${this.dashboardKey}`,
            'replace',
            '/widgets',
            JSON.stringify(data),
            WidgetApiDataSchema
        );
    }

    async load(): Promise<WidgetApiDataType | null> {
        let f = new ApiFilterBuilder(1);
        f.setProjectionFields(['widgets']);
        let arrayOfWidgets = await this.api.getData<undefined, { widgets: string | null }>(
            'get',
            `/dashboard_template/${this.dashboardKey}` + f.getUri(),
            undefined,
            z.undefined(),
            z.object({ widgets: z.string().nullable() })
        );
        console.log('WidgetApi, string to convertion', arrayOfWidgets?.widgets);
        let widgets = WidgetApiDataSchema.nullable()
            .catch(null)
            .parse(JSON.parse(arrayOfWidgets?.widgets ?? '{}'));
        return new Promise(resolve => {
            resolve(widgets);
        });
    }

    // async save(data: WidgetApiDataType): Promise<any> {
    //     console.log('WidgetApi, Save', this.dashboardKey, data);
    //     return SettingsApi.setClientSettings(
    //         get(api),
    //         this.dashboardKey,
    //         data,
    //         WidgetApiDataSchema
    //     );
    // }
    //
    // async load(): Promise<WidgetApiDataType> {
    //     let data: WidgetApiDataType = await SettingsApi.getClientSettings(
    //         get(api),
    //         this.dashboardKey,
    //         WidgetApiDataSchema
    //     );
    //     console.log('WidgetApi, Load', this.dashboardKey, data);
    //     return new Promise(resolve => {
    //         resolve(data);
    //     });
    // }
}
